module.exports = __webpack_public_path__ + "img/transunion.4f0f4a05.svg";